export class Query<TResult> {
    // INFO: Hack żeby TSowy type checker, nie gubił informacji o typie.
    public readonly __result__!: TResult;
 }

export interface QueryHandler<TQuery extends Query<TResult>, TResult = TQuery extends Query<infer TR> ? TR : unknown> {
    handleAsync(query: TQuery, params?: any): Promise<TResult>;
}
